import ReactDOM from "react-dom/client";
import { App } from "./App/App";
import { WIDGET_CSS } from "./styles";

const scriptTag = document.currentScript as HTMLScriptElement | null;

if (scriptTag) {
  const serverUrl =
    scriptTag.dataset.serverUrl ?? new URL(scriptTag.src).origin;
  const avatarUrl =
    scriptTag.dataset.avatarUrl ?? `${serverUrl}/assets/courtney-hero.png`;
  const agentName = scriptTag.dataset.agentName ?? "courtney";

  // ── Configurable widget offsets ──
  // Separate desktop and mobile defaults — setting one platform's offset
  // does NOT affect the other. Values are in pixels (unitless in the attribute).
  const offsets = {
    desktopRight: scriptTag.dataset.desktopOffsetRight,
    desktopBottom: scriptTag.dataset.desktopOffsetBottom,
    mobileRight: scriptTag.dataset.mobileOffsetRight,
    mobileBottom: scriptTag.dataset.mobileOffsetBottom,
  };

  // Build a CSS override block that only sets the properties the implementer
  // explicitly provided — everything else falls back to the defaults in styles.ts.
  const overrides: string[] = [];
  if (offsets.desktopRight)
    overrides.push(`--wg-desktop-offset-right: ${offsets.desktopRight}px`);
  if (offsets.desktopBottom)
    overrides.push(`--wg-desktop-offset-bottom: ${offsets.desktopBottom}px`);
  if (offsets.mobileRight)
    overrides.push(`--wg-mobile-offset-right: ${offsets.mobileRight}px`);
  if (offsets.mobileBottom)
    overrides.push(`--wg-mobile-offset-bottom: ${offsets.mobileBottom}px`);

  const offsetCSS = overrides.length
    ? `:host { ${overrides.join("; ")}; }`
    : "";

  // Load Manrope at the document level. The styles.ts @import sits inside the
  // shadow root, which works in modern browsers but loads on a separate cycle
  // — first paint can flash with the system fallback (SF on macOS), which has
  // heavier glyphs at the same weight. Document-level injection gets the font
  // into the browser's font cache before the shadow root mounts.
  if (!document.querySelector('link[data-lk-widget-font="manrope"]')) {
    const preconnect = document.createElement("link");
    preconnect.rel = "preconnect";
    preconnect.href = "https://fonts.gstatic.com";
    preconnect.crossOrigin = "anonymous";
    document.head.appendChild(preconnect);

    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href =
      "https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=swap";
    fontLink.dataset.lkWidgetFont = "manrope";
    document.head.appendChild(fontLink);
  }

  const wrapper = document.createElement("div");
  wrapper.id = "lk-widget-wrapper";
  document.body.appendChild(wrapper);

  const shadow = wrapper.attachShadow({ mode: "open" });

  const style = document.createElement("style");
  style.textContent = WIDGET_CSS + offsetCSS;
  shadow.appendChild(style);

  const reactRoot = document.createElement("div");
  shadow.appendChild(reactRoot);

  // Render immediately. AgentSession reads window.__courtsapp_user live at
  // token-request time, so user data is picked up when the chat actually opens.
  const root = ReactDOM.createRoot(reactRoot);
  root.render(
    <App
      serverUrl={serverUrl}
      avatarUrl={avatarUrl}
      agentName={agentName}
    />,
  );
} else {
  console.error(
    "[livekit-widget] Could not find the script tag. Make sure the script is loaded synchronously.",
  );
}
